import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import Dashboard from '../../components/pages/dashboard';
import RoutesWithNavbar from './routes-with-navbar';
import Profile from '../../components/pages/profile/profile';
import BankAccounts from '../../components/pages/bank-accounts/bank-accounts';
import Login from '../../components/pages/login/login';
import Footer from '../../components/layout/footer/footer';

const AzureAppRoutes = () => {
   return (
      <Routes>
         <Route
            path="/"
            element={
               <div className="min-vh-100 d-flex flex-column">
                  <RoutesWithNavbar />
                  <Dashboard />
                  <Footer />
               </div>
            }
         />
         <Route
            path="/profile"
            element={
               <div className="min-vh-100 d-flex flex-column">
                  <RoutesWithNavbar />
                  <Profile />
                  <Footer />
               </div>
            }
         />
         <Route
            path="/bank-accounts"
            element={
               <div className="min-vh-100 d-flex flex-column">
                  <RoutesWithNavbar />
                  <BankAccounts />
                  <Footer />
               </div>
            }
         />
         <Route
            path="/login"
            element={
               <>
                  <RoutesWithNavbar />
                  <Login />
               </>
            }
         />
         <Route path="*" element={<Navigate to="/" />} />
      </Routes>
   );
};

export default AzureAppRoutes;
